"use client";
import { createContext, useState } from "react";

// Create the context
const GlobalCtx = createContext({
  invoiceItems: [],
  setInvoiceItems: (invoiceItems: any) => {},
});

// Create a provider component
export const GlobalProvider = ({ children }: any) => {
  const [invoiceItems, setInvoiceItems] = useState([]);
  const context = { invoiceItems, setInvoiceItems };
  return <GlobalCtx.Provider value={context}>{children}</GlobalCtx.Provider>;
};

export default GlobalCtx;
